exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cloud-provider-logo .icon-openstack {\n  background: url(" + require("./openstack.logo.svg") + ") no-repeat 50% 50%;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/openstack/src/logo/openstack.logo.less
// module id = 3713
// module chunks = 0